// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"74c218a0","823":"c85626f5"}[chunkId] + ".chunk.js";
};